import { render, staticRenderFns } from "./new-product.modal.vue?vue&type=template&id=676d360e&scoped=true&"
import script from "./new-product.modal.vue?vue&type=script&lang=js&"
export * from "./new-product.modal.vue?vue&type=script&lang=js&"
import style0 from "./new-product.modal.vue?vue&type=style&index=0&id=676d360e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676d360e",
  null
  
)

export default component.exports